import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForManualFeatureOnboarding(context: EditionAwarenessContextType) {
	const { isInTrial, isInvoiceable, userRoles, lastKnownTrial, product } = context;

	return Boolean(
		product === 'confluence' &&
			isInTrial &&
			isInvoiceable &&
			userRoles?.includes('SITE_ADMIN') &&
			lastKnownTrial?.trialType === 'MANUAL_TRIAL',
	);
}
